// src/shared/utils/customerSwitchNav.ts
//
// Entity-detail routes are scoped to the selected customer: after a sub-account
// switch, the entity in the URL belongs to the previous account and cannot
// resolve under the new cId (the detail query 404s). Rather than strand the
// user on a "not found" page, switching redirects to the section's list route,
// which refetches naturally for the new account. List/index routes need no
// redirect — their queries re-key on selectedCId in place.

/**
 * Section roots whose child routes address selectedCId-scoped entities.
 * Longest-prefix-first so `/apps/content/...` resolves before `/apps/...`.
 */
const CUSTOMER_SCOPED_SECTION_ROOTS = [
  '/apps/content',
  '/account/team',
  '/videos',
  '/streams',
  '/playlists',
  '/players',
  '/feeds',
  '/apps',
] as const;

export type CustomerScopedSectionRoot = (typeof CUSTOMER_SCOPED_SECTION_ROOTS)[number];

export class CustomerSwitchNav {
  /**
   * Returns the list route to land on after a customer switch, or null when
   * the current location is already safe (list/index routes, dashboard,
   * analytics, account pages that follow the selection).
   */
  static getRedirectPath(pathname: string): CustomerScopedSectionRoot | null {
    const path = pathname.replace(/\/+$/, '');
    for (const root of CUSTOMER_SCOPED_SECTION_ROOTS) {
      if (path === root) return null;
      if (path.startsWith(`${root}/`)) return root;
    }
    return null;
  }
}
